import { getDataLayer } from "./DataLayer"

export const ProfitWell = {
    onUserAuthenticated: (email: string) => {
        const dataLayer = getDataLayer();
        dataLayer.push({ 'event': 'start_pw', 'pw_user_email': email })
    },
    onAnonymousUser: () => {
        const dataLayer = getDataLayer();
        dataLayer.push({ 'event': 'start_pw' })
    }
}